module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue5.7ef51e76.jpg";